/**
 * Utility functions for generating slugs from titles and names
 */

/**
 * Generate a URL-friendly slug from a title or name
 * @param {string} title - The title or name to convert to a slug
 * @returns {string} - The generated slug
 */
export const generateSlug = (title) => {
  if (!title) return '';
  
  return title
    .toLowerCase()
    .normalize('NFD') // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};

/**
 * Generate a slug for an article, using custom slug if provided, otherwise generating from title
 * @param {Object} article - The article object with title and optional slug
 * @returns {string} - The generated or custom slug
 */
export const generateArticleSlug = (article) => {
  if (!article) return '';
  
  // If article has a custom slug defined and it's not empty, use it
  if (article.slug && article.slug.trim()) {
    return article.slug.trim();
  }
  
  // Otherwise, generate slug from title (backward compatibility)
  return generateSlug(article.title);
};

/**
 * Generate a slug specifically for city names (handles special characters)
 * @param {string} cityName - The city name to convert to a slug
 * @returns {string} - The generated city slug
 */
export const generateCitySlug = (cityName) => {
  if (!cityName) return '';
  
  return cityName
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};
